export default "__VITE_ASSET__DLjBA7Kh__"